module.exports = __webpack_public_path__ + "static/media/ABELCoaches_USA.bb4007ea.png";